import * as React from "react";
import { forwardRef } from "react";
const SvgUsers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 22,
	viewBox: "0 0 24 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M8.76938 8.93598C10.7767 8.93598 12.404 7.30871 12.404 5.30136C12.404 3.29402 10.7767 1.66675 8.76938 1.66675C6.76204 1.66675 5.13477 3.29402 5.13477 5.30136C5.13477 7.30871 6.76204 8.93598 8.76938 8.93598Z",
	stroke: "white",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16.0385 21.0514H1.5V19.436C1.5 17.5081 2.26586 15.6591 3.62911 14.2959C4.99235 12.9326 6.84131 12.1667 8.76923 12.1667C10.6971 12.1667 12.5461 12.9326 13.9094 14.2959C15.2726 15.6591 16.0385 17.5081 16.0385 19.436V21.0514Z",
	stroke: "white",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.2305 1.66675C16.1944 1.66675 17.1189 2.04968 17.8005 2.7313C18.4821 3.41292 18.8651 4.3374 18.8651 5.30136C18.8651 6.26532 18.4821 7.1898 17.8005 7.87143C17.1189 8.55305 16.1944 8.93598 15.2305 8.93598",
	stroke: "white",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17.8145 12.4736C19.1905 12.9971 20.3752 13.926 21.2117 15.1376C22.0482 16.3491 22.4971 17.786 22.4991 19.2583V21.0513H20.076",
	stroke: "white",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgUsers);
export default ForwardRef;
